<div class="atcd-panel" [class.atcd-panel--collapsed]="collapsed">

  <div class="atcd-panel__toggle">
    <div class="atcd-panel__toggle-handle" (click)="togglePanel()">
      <div class="atcd-panel__toggle-chevron">
        {{ collapsed ? '◀' : '▶' }}
      </div>
      <div class="atcd-panel__toggle-label">ATCD</div>
    </div>
  </div>

  <div class="atcd-panel__content" *ngIf="!collapsed">
    <div class="atcd-panel__header">
      <div class="atcd-panel__title">Antécédents</div>

      <button
        type="button"
        class="atcd-panel__close-btn"
        (click)="togglePanel()">
        ✕
      </button>
    </div>

    <div class="atcd-panel__body">
      <div class="atcd-loader" *ngIf="isLoading">
        Chargement des antécédents...
      </div>

      <ng-container *ngIf="!isLoading">
        <div class="atcd-section" [ngClass]="getSectionClasses(section)"
        *ngFor="let section of visibleSections"
        cdkDropList
        [id]="'atcd-drop-' + section.key"
        [cdkDropListData]="section"
        [cdkDropListDisabled]="!section.droppable"
        [cdkDropListSortingDisabled]="true"
        (cdkDropListDropped)="onDrop($event, section)"
        (cdkDropListEntered)="onDropEntered(section)"
        (cdkDropListExited)="onDropExited(section)">

          <button
            type="button"
            class="atcd-section__header"
            (click)="toggleSection(section)">
            <span class="atcd-section__title">
              <span
                class="atcd-section__dot"
                [ngClass]="'atcd-section__dot--' + section.key">
              </span>
              {{ section.label }} ({{ section.items.length }})
            </span>

            <span class="atcd-section__header-right">
              <span class="atcd-section__drop-hint" *ngIf="section.droppable">
                Dépôt
              </span>

              <span class="atcd-section__chevron">
                {{ section.expanded ? '▾' : '▸' }}
              </span>
            </span>
          </button>

          <div class="atcd-section__content" *ngIf="section.expanded"
            cdkDropList [id]="'atcd-items-' + section.key"
            [cdkDropListData]="section.items"
            [cdkDropListSortingDisabled]="true" [cdkDropListConnectedTo]="connectedDropListIds">
            <ng-container *ngIf="section.items.length > 0; else emptySection">
              <div class="atcd-item" *ngFor="let item of section.items"
              cdkDrag [cdkDragData]="buildAtcdDragData(section, item)" [cdkDragDisabled]="!antecedentCritereId">
                <ng-template cdkDragPreview>
                  <div class="drag-preview-simple">
                    <span class="drag-preview-simple__label">{{ item.label }}</span>
                    <span class="drag-preview-simple__value" *ngIf="item.comment || item.dateLabel">
                      {{ item.comment || item.dateLabel }}
                    </span>
                  </div>
                </ng-template>

                <div class="atcd-item__top">
                  <div class="atcd-item__label">{{ item.label }}</div>

                  <div class="atcd-item__badges">
                    <span class="atcd-item__badge atcd-item__badge--date" *ngIf="item.dateLabel">
                      {{ item.dateLabel }}
                    </span>
                  </div>
                </div>

                <div class="atcd-item__code" *ngIf="item.code">
                  {{ item.code }}
                </div>

                <div class="atcd-item__comment" *ngIf="item.comment">
                  {{ item.comment }}
                </div>
              </div>
            </ng-container>

            <ng-template #emptySection>
              <div class="atcd-section__empty">Aucun élément</div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

</div>
